import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import Cookies from "js-cookie";

export const appliedJobApi = createApi({
  reducerPath: "appliedJobApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
    prepareHeaders: (headers) => {
        const token = Cookies.get('authToken');
      if (token) {
        headers.set("Authorization", `${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    appliedJobapi: builder.query({
      query: () => `/user/applied/all-job`,
    }),
  }),
});

export const { useAppliedJobapiQuery } = appliedJobApi;
